import styled from 'styled-components'

export const ModalButtonContainer = styled.button``
